
import React from 'react';
import Layout from '@/components/layout/Layout';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import FinancePaymentCalendar from '@/components/finance/FinancePaymentCalendar';

const FinancePaymentsCalendar = () => {
  return (
    <Layout>
      <div className="w-full max-w-full py-8">
        <h1 className="text-3xl font-bold mb-8">Payment Calendar</h1>
        
        <Card className="w-full">
          <CardHeader>
            <CardTitle>Payment Calendar</CardTitle>
          </CardHeader>
          <CardContent className="pt-6">
            <FinancePaymentCalendar />
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

export default FinancePaymentsCalendar;
